import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './LandingPageSection2.module.css';

gsap.registerPlugin(ScrollTrigger);

const LandingPageSection2 = () => {
  const gridRef = useRef(null);

  const features = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2l2.4 4.9 5.3.8-3.8 3.7.9 5.3-4.8-2.5-4.8 2.5.9-5.3-3.8-3.7 5.3-.8L12 2z" fill="white" />
        </svg>
      ),
      title: "Human-like voice",
      desc: "Natural cadence, tone, and empathy."
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 21h2v-8h5l-6-9-6 9h5v8z" fill="white" />
        </svg>
      ),
      title: "Sub-second latency",
      desc: "Feels like a live conversation."
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="white" />
        </svg>
      ),
      title: "60+ languages",
      desc: "Localized for every market."
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 19h4V5H5v14zm6 0h4v-9h-4v9zm6 0h4V13h-4v6z" fill="white" />
        </svg>
      ),
      title: "Real-time analytics",
      desc: "Sentiment, intent, outcomes."
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L4 5v6c0 5.25 3.42 10.16 8 11.5 4.58-1.34 8-6.25 8-11.5V5l-8-3zm-1 14.5l-4-4 1.41-1.41L11 13.67l5.59-5.59L18 9.5l-7 7z" fill="white" />
        </svg>
      ),
      title: "Bank-level security",
      desc: "SOC 2 · HIPAA · GDPR."
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2a5 5 0 0 0-5 5v3H5v12h14V10h-2V7a5 5 0 0 0-5-5zm3 8H9V7c0-1.66 1.34-3 3-3s3 1.34 3 3v3z" fill="white" />
        </svg>
      ),
      title: "Warm handoffs",
      desc: "Zero-drop transfers to humans."
    }
  ];

  useEffect(() => {
    const cards = gridRef.current.querySelectorAll(`.${styles.card}`);
    
    gsap.fromTo(
      cards,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: gridRef.current,
          start: "top 80%"
        }
      }
    );
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.headline}>
            Powerful features that <br />
            <span className={styles.gradientText}>drive results.</span>
          </h2>
          <p className={styles.subheadline}>
            Everything you need to launch, scale, and refine your AI voice workforce.
          </p>
        </div>

        <div className={styles.grid} ref={gridRef}>
          {features.map((item, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.iconCircle}>
                <span className={styles.icon}>{item.icon}</span>
              </div>
              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardDesc}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingPageSection2;